import React from 'react'
import {API_BASE_URL, RECEIPT_LIST_PAGE_SIZE} from '../../constants'
import Select from 'react-select';
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, setLocalKeyValue, getLocalKeyValue, getDateRange} from '../../storage'
import {DRN} from '../report/daterange'
import {Link } from 'react-router-dom'
import DateFormat from '../../utils/dateformat'
import {Currency} from '../../utils/currency'
import SearchInput from '../search/search'
import {updateHistory} from '../commons/functions'
export default class ReceiptList extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      dateRange : getDateRange(),
      tableState: {},
      data: [],
      pages: null,
      loading: true,
      client: props.location.state ? (props.location.state.client || null): null,
    };
    this.fetchList = this.fetchList.bind(this)
    this.fetchData = this.fetchData.bind(this);
    this.deleteReceipt = this.deleteReceipt.bind(this)
    this.deleteFormat = this.deleteFormat.bind(this)
    this.handleSearchInput = this.handleSearchInput.bind(this)
    document.title = "Receipts List"
  }

  handleSearchInput(q) {
    this.fetchData(this.state.tableState, {}, q)
  }

  downloadReport = (report_type) => {
    return   axios({
      url: report_type,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }



  downloadReceipts = (xls_url) =>{
    this.setState({downloading_receipts:true,})

    let apiurl = xls_url
    if(this.state.query) {
      apiurl = apiurl + "&q="+this.state.query
    }
    let dateRange = this.state.dateRange
    if(dateRange) {
      let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
      let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
      let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
      let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
      apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
    }
    let client = this.state.client
    if(typeof client !== "undefined" && client !== null) {
      apiurl = apiurl + '&client_id='+client.id
    }

    this.downloadReport(apiurl).then((response)=> {
      this.setState({submitting_rate_sales:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

    }).catch((err)=> {
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }


  getClients = (input) =>{

    return   axios({
        url: '/list_clients/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.clients}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
  }

  handleClientChange =(value) =>{
    this.setState({client: value})
    this.fetchData(this.state.tableState, {}, this.state.query, this.state.dateRange, value)
    updateHistory(this.props, {client:value})
  }

  renderClientName(option){
    return <span>{option.name} {option.city}</span>
  }


    deleteReceipt(receipt_id) {

      var confirmation = window.confirm('Are you sure about delete ?')

      if(confirmation) {
        axios({
          url: '/delete_receipt/',
          baseURL: API_BASE_URL,
          method:'post',
          data: {id:receipt_id},
          headers: {
            common: {
              'Authorization': 'Token ' + getToken()
            }
          }
        }).then(res => {
          this.fetchList()
        }).catch(err=>{
          console.log(err);
        })
      }
    }

    applyDateRange = (dateRange) => {
      this.fetchData(this.state.tableState, {}, this.state.query, dateRange)

    }

    fetchList(state=this.state.tableState, query=this.state.query, dateRange=this.state.dateRange, client=this.state.client) {

      this.setState({ loading: true });
      setLocalKeyValue(RECEIPT_LIST_PAGE_SIZE, state.pageSize)
      let apiurl = "/list_receipts/?require_pagination=true&page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }

      if(query) {
        apiurl = apiurl + "&q="+query
      }

      if(typeof client !== "undefined" && client !== null) {
        apiurl = apiurl + '&client_id='+client.id
      }

      if(dateRange) {
        let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
        let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
        let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
        let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
        apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
      }

      this.setState({tableState:state, query:query, dateRange:dateRange, client:client})
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.receipts,
          pages: res.data.pages,
          loading: false
        });
      });

    }

    fetchData(state, instance, query=this.state.query, dateRange=this.state.dateRange, client=this.state.client) {
      this.fetchList(state, query, dateRange, client)
    }

    deleteFormat(row) {
      return <button className="btn btn-sm btn-danger" onClick={e=>this.deleteReceipt(row.original.id)}>Delete</button>
    }

    clientFormat(row) {

      let invoice = row.original.invoice
      if (typeof row.original.client !== "undefined" && row.original.client !== null) {
        return row.original.client.name
      }
      else {
        return null
      }
    }

    invoiceFormat(row) {
      let invoice = row.original.invoice
      if(typeof invoice !== "undefined" && invoice !== null) {
        return <Link to={"/invoices/edit/"+invoice.serial}>Invoice {invoice.series_name + invoice.series_counter }</Link>
      }

      else {
        return null
      }
    }


    render() {

      const { data, pages, loading } = this.state;
      let xls_url = "/export_receipts_excel/?"

      const amountHeader = <div><Currency /> Amount</div>
      const columns = [
        {Header:'Date',  accessor:'date',sortable:true,  Cell:(row)=>(<DateFormat date={row.original.date}/>)},
        {Header:'Client', accessor:'client.name', sortable:false, Cell:(row)=>{return this.clientFormat(row)}},
        {Header:'Invoice', sortable:false, Cell:(row)=>{return this.invoiceFormat(row)}},

        {Header:amountHeader,  accessor:'amount',sortable:true, Cell:(row)=>(<div className="text-right">{row.original.amount}</div>)},
        {Header:'Mode', accessor: 'mode',sortable:false },
        {Header:'Reference', accessor: 'reference',sortable:false },
        {Header:'Notes', accessor: 'notes',sortable:false },
        {Header:'', Cell:(row)=>  {return this.deleteFormat(row)}}
      ]
      const defaultSort=[{id: "date", desc: true}]
      let pageSize = getLocalKeyValue(RECEIPT_LIST_PAGE_SIZE)

      if(typeof pageSize === "undefined"){
        pageSize = 20
      }
      else {
        pageSize = parseInt(pageSize, 10)
      }

      return <div>

      <section className="medium">
        <div className="row">
          <div className="col-sm-3">
          <Link to="/receipts/create" className="btn btn-primary">Add New Receipt</Link>
          </div>
          <div className="col-sm-3 mtop">
            <SearchInput handleSearchInput={this.handleSearchInput} placeholder={"Search Invoices"} />
          </div>
          <div className="col-sm-3 col-lg-2 col-lg-offset-1">
            <div className="row mtop">
                <div className="col-md-12 ">
                <Select.Async multi={false} onChange={this.handleClientChange} valueRenderer={this.renderClientName}
                optionRenderer={this.renderClientName} value={this.state.client} valueKey="id" labelKey="name"
                loadOptions={this.getClients} backspaceRemoves={true} placeholder="Select Client"/>
                </div>
            </div>


          </div>

          <div className="col-sm-3 col-lg-2 mtop col-lg-offset-1">
            <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
          </div>
        </div>

      </section>

      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <div className="text-right"><button className="btn btn-default btn-sm" onClick={(e)=>{this.downloadReceipts(xls_url)}}>Download xls</button></div>
            <ReactTable defaultSorted={defaultSort}
              noDataText="No Receipts Found."

                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={pageSize} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/receipt/receiptlist.js